import type {PurchaseBatch} from './governanceTypes';

export function batchReference(batch: Pick<PurchaseBatch,'purchasedOn'|'dailySequence'|'name'>) {
  return batch.purchasedOn && batch.dailySequence
    ? `${batch.purchasedOn} · ${String(batch.dailySequence).padStart(2,'0')}`
    : batch.name;
}

export function stockPointToday(zone:string) {
  const parts=new Intl.DateTimeFormat('en-GB',{timeZone:zone,year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
  return ['year','month','day'].map(key=>parts.find(p=>p.type===key)!.value).join('-');
}
